interface IPanesState {
  showLeft: boolean;
  leftType?: ValueOf<IPanes>;
  showRight: boolean;
  rightType?: ValueOf<IPanes>;
}

const actions = {
  SHOW_LEFT: 'lms-ui/panes/SHOW_LEFT',
  SHOW_RIGHT: 'lms-ui/panes/SHOW_RIGHT',
};

interface IPanesAction {
  type: typeof actions.SHOW_LEFT | typeof actions.SHOW_RIGHT;
  payload?: { show?: boolean; type?: ValueOf<IPanes> };
}

type PanesActionTypes = IPanesAction;

const initialState: IPanesState = {
  showLeft: false,
  showRight: false,
};

export const showLeftPane = (show?: boolean, type?: ValueOf<IPanes>): PanesActionTypes => {
  return { type: actions.SHOW_LEFT, payload: { show, type } };
};

export const showRightPane = (show?: boolean, type?: ValueOf<IPanes>): PanesActionTypes => {
  return { type: actions.SHOW_LEFT, payload: { show, type } };
};

export default function reducer(state = initialState, action: PanesActionTypes): IPanesState {
  switch (action.type) {
    case actions.SHOW_LEFT: {
      return {
        ...state,
        showLeft: !!action.payload?.show,
        leftType: action.payload?.type,
      };
    }
    case actions.SHOW_RIGHT: {
      return {
        ...state,
        showRight: !!action.payload?.show,
        rightType: action.payload?.type,
      };
    }
    default:
      return state;
  }
}
